/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAllotmentReportDetailAmountFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type AllotmentReportDetailAmount, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AllotmentReport/{requestId}
 */
export interface WithRequestItemRequestBuilder extends BaseRequestBuilder<WithRequestItemRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AllotmentReportDetailAmount[]>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AllotmentReportDetailAmount[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithRequestItemRequestBuilderUriTemplate = "{+baseurl}/AllotmentReport/{requestId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithRequestItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithRequestItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createAllotmentReportDetailAmountFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
